import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-left",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "calendar-month" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { Locale, format } from 'date-fns'
  import { toRefs } from 'vue'

  interface Props {
    day: Date
    localeOptions: Locale
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    day: null,
    localeOptions: null
  },
  emits: ['displayNextMonth', 'displayPreviousMonth'],
  setup(__props: any, { emit }) {

const props = __props as {
    day: Date
    localeOptions: Locale
  }

  

  

  const { day, localeOptions } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "calendar-arrow calendar-arrow-left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('displayPreviousMonth')))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(_unref(format)(_unref(day), 'MMM yyyy', { locale: _unref(localeOptions) })), 1)
    ]),
    _createElementVNode("div", {
      class: "calendar-arrow calendar-arrow-right",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('displayNextMonth')))
    }, _hoisted_6)
  ]))
}
}

})